import Slide from "react-reveal/Slide";
import {
  AgentContainer,
  AgentWrapper,
  AgentRow,
  Column1,
  Column2,
  TextWrapper,
  Heading,
  Subtitle,
  CTASection,
  ImgWrap,
  Img,
} from "./AgentElements";

import { CTAButton } from "../BusinessSection/BusinessElements";

const AgentSection = ({ id, headline, imgStart, img, alt, buttonLabel }) => {
  return (
    <>
      <AgentContainer id={id}>
        <AgentWrapper>
          <AgentRow imgStart={imgStart}>
            <Slide right>
              <Column1>
                <TextWrapper>
                  <Heading>{headline}</Heading>
                  <Subtitle>
                    Join the Paythumb Agent Program (PAP) and get paid instantly
                    whenever you link fingerprints to Paythumb wallets.
                  </Subtitle>
                </TextWrapper>

                <CTASection>
                  <CTAButton
                    to="Waitlist"
                    smooth={true}
                    duration={500}
                    spy={true}
                    exact="true"
                    offset={-80}
                  >
                    Join Wait list
                  </CTAButton>
                </CTASection>
              </Column1>
            </Slide>
            <Column2>
              <ImgWrap>
                <Img src={img} alt={alt} />
              </ImgWrap>
            </Column2>
          </AgentRow>
        </AgentWrapper>
      </AgentContainer>
    </>
  );
};

export default AgentSection;
